

import { useSelector } from "react-redux";
import { Card, Table, Typography, Spin } from 'antd';
import { useGetAngeloneHoldingQuery } from "../slices/angelOneApiSlice";
import "./css/Dashboard.css";
const { Title, Text } = Typography;

const holdingColumns = [
  {
    title: 'Symbol',
    dataIndex: 'tradingsymbol',
    key: 'symbol',
  },
  {
    title: 'Exchange',
    dataIndex: 'exchange',
    key: 'exchange',
      className: 'no-wrap-header',

//       width: 100, // or try minWidth if using CSS style

//     onCell: () => ({
//       style: {
//  whiteSpace:'nowrap ,!important'      },
//     }),
  },
  {
    title: 'Qty',
    dataIndex: 'quantity',
    key: 'qty',
    onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
  },
  {
    title: 'Avg. Price',
    dataIndex: 'averageprice',
    key: 'avgPrice',
    render: (value) => `₹${value.toFixed(2)}`,

       onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
  },
  {
    title: 'LTP',
    dataIndex: 'ltp',
    key: 'ltp',
    render: (value) => `₹${value.toFixed(2)}`
  },
  {
    title: 'P&L',
    dataIndex: 'profitandloss',
    key: 'pnl',
    render: (value) => (
      <span style={{ color: value >= 0 ? 'green' : 'red' }}>
        ₹{value}
      </span>
    ),
       onCell: () => ({
      style: {
        whiteSpace: 'nowrap',
      },
    }),
  },
  {
    title: 'PnL %',
    dataIndex: 'pnlpercentage',
    key: 'pnlPercentage',
    render: (value) => (
      <span style={{ color: value >= 0 ? 'green' : 'red' }}>
        {value.toFixed(2)}%
      </span>
    )
  },
  {
    title: 'Product',
    dataIndex: 'product',
    key: 'product',
  },
  {
    title: 'ISIN',
    dataIndex: 'isin',
    key: 'isin',
  },
];

const HoldingScreen = ({broker}) => {
console.log(broker);


  const { userInfo } = useSelector((state) => state.auth); // Assuming you store logged-in user info here
  const userId = userInfo?._id;
  console.log(userId);
  
const { data: holdingsData, isLoading } =
  useGetAngeloneHoldingQuery({
    userId,
    broker,
  });
  const { darkmode } = useSelector((state) => state.darkmode);
console.log("holdings..",holdingsData);
  return (
    <Card
      title="Holdings"
      bordered={false}
      className="card_hover"
      style={{
        backgroundColor: darkmode ? "#1f1f1f" : "#fff",height:"500px",marginTop:"30px",

        overflowX: "auto",height:"500px",marginTop:"30px"

      }}
    >
      {isLoading ? (
  <Spin />
) : (
  <div style={{ overflowX: 'auto',overflowY:"auto" }}>
    <Table
      // dataSource={Array.isArray(holdingsData?.holdings) ? holdingsData.holdings : []}
        // dataSource={Array.isArray(holdingsData?.holdings?.data) ? holdingsData.holdings.data : []}
dataSource={holdingsData?.holdings || []}

      columns={holdingColumns}
      pagination={false}
scroll={{ x: 'max-content' }}
      bordered
      // scroll={{ x: true,y :true }}
      style={{ overflowX: 'auto', }}
      rowKey="tradingsymbol"
    />
  </div>
)}

    </Card>
  );
};

export default HoldingScreen;
